import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSlotModule } from '@spartacus/storefront';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { PrimengModule } from '../primeng/primeng.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';

import { CustomRouteGuard } from '../../SGRE-shared/services/guard/msal.guard';

import { SavedCartsService } from './services/saved-carts.service';
import { ManageCartsEffectService } from './store/effects/manage-carts-effects.service';
import { savedCartsTrackingService } from './services/saved-carts-tracking.service';

import { SaveCartComponent } from './components/save-cart/save-cart.component';
import { SavedCartModule } from '@spartacus/cart/saved-cart';
import { StoreModule } from "@ngrx/store";
import { combinedCartReducer } from '../save-cart/store/reducer/index';
import { EffectsModule } from '@ngrx/effects';
import { SAVED_CARTS_MODULE } from './store/state/cart-details.state';
import { effects } from './store/effects/index';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    SaveCartComponent
  ],
  imports: [
    CommonModule,
    SavedCartModule,
    PageSlotModule,
    StoreModule.forFeature(SAVED_CARTS_MODULE, combinedCartReducer),
    EffectsModule.forFeature(effects),
    PrimengModule,
    ReactiveFormsModule,
    SGRESharedModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SavedCartTableComponent: {
          component: () => import('./components/save-cart/save-cart.component').then(m => m.SaveCartComponent),
          guards: [CustomRouteGuard]
        }
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule
  ],
  providers: [
    TranslateService,
    { provide: TranslateStore },
    SavedCartsService,
    ManageCartsEffectService,
    savedCartsTrackingService,
  ]
})
export class SaveCartModule { }